import $ from 'jquery';
import Swiper from '../../node_modules/swiper/js/swiper.min.js';

$.addInit(function(context){
	var base = '.b-mediaSlider';
	$(base, context).each(function(i, el){
		setTimeout(function() {
			new Swiper (el.querySelector('.b-mediaSlider-container'), {
				slidesPerView: 'auto',
				spaceBetween: 0,
				slideClass: 'b-media',
				navigation : {
					nextEl : el.querySelector('.b-sliderArrows-btn_next'),
					prevEl : el.querySelector('.b-sliderArrows-btn_prev')
				},
			});
		});
	});
});
